const updateHistory = () => {
  // Don't update if the quicklook modal is open
  const quicklookModal = document.getElementById('quicklook-modal');
  if (quicklookModal && quicklookModal.offsetParent !== null) {
    return false;
  }

  const select = document.querySelector('[data-product-select]');
  let selected_variant = select ? select.value : undefined;

  if (typeof selected_variant === 'undefined' || selected_variant == null) {
    const inactiveActiveSize = document.querySelector('[data-product-option-sizes] li.inactive.active');
    if (inactiveActiveSize) {
      const selectedOption = select ? select.options[select.selectedIndex] : null;
      selected_variant = selectedOption ? selectedOption.value : undefined;
    } else {
      const firstOption = select ? select.querySelector('option') : null;
      selected_variant = firstOption ? firstOption.value : undefined;
    }
  }

  const page_url = new URL(window.location.href);
  const search_params = new URLSearchParams(page_url.search);

  // We need to keep the previous QS due to marketing campaigns
  // Note that we keep it even if the variant changes (OOS variant gets redirected to in-stock variant) which might not be ideal to track the exact conversions but has been requested by Rockerbox
  const all_params = Object.fromEntries(search_params.entries());
  all_params.variant = selected_variant;
  if (search_params.has('color')) {
    delete all_params.color;
  }
  const qs = Object.keys(all_params).map((key) => `${key}=${all_params[key]}`).join('&');
  const new_url = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${qs}${window.location.hash}`;
  window.history.replaceState({ path: new_url }, '', new_url);

  // We need to keep the previous QS due to marketing campaigns
  // if (search_params.get('variant') !== selected_variant) {
  //   const new_url = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${selected_variant}`;
  //   window.history.replaceState({ path: new_url }, '', new_url);
  //    // window.history.pushState({ path: new_url }, '', new_url);
  // }

  return true;
};

const getProductJson = () => {
  const el = document.querySelector('[data-product-json]');
  if (!el) {
    return [];
  }

  return JSON.parse(el.innerHTML);
};

const getProductCollectionsJson = () => {
  const el = document.querySelector('[data-product-collections-json]');
  if (el) {
    return JSON.parse(el.innerHTML);
  }

  return [];
};

const getSelectedVariantId = () => {
  const select = document.querySelector('[data-product-select]');
  const selectedOption = select ? select.options[select.selectedIndex] : null;
  return selectedOption ? parseInt(selectedOption.value, 10) : null;
};

const getSelectedVariantByIdJson = () => {
  const p_json = getProductJson();
  return p_json.variants.find(variant => variant.id === getSelectedVariantId());
};

const getVariantsByColor = (selected_color) => {
  const colorEl = document.querySelector('[data-option-color]');
  const color_index = colorEl ? Number(colorEl.getAttribute('data-option-index')) : 0;
  let filter_key = 'option1';
  if (color_index === 1) filter_key = 'option2';
  if (color_index === 2) filter_key = 'option3';

  return getProductJson().variants.filter(variant => variant[filter_key] === selected_color);
};

// Single option product (gift card for instance)
const getVariantBySingleOption = (selected_single_option) => {
  return getProductJson().variants.find(variant => variant.option1 === selected_single_option);
};

const getAvailableProductColors = () => {
  const product = getProductJson();
  const colors = [];
  product.variants.forEach((variant) => {
    if (variant.available) {
      if (!colors.includes(variant.option1)) {
        colors.push(variant.option1);
      }
    }
  });

  // console.log('available colors', colors);

  return colors;
};

export {
  updateHistory,
  getProductJson,
  getProductCollectionsJson,
  getSelectedVariantByIdJson,
  getSelectedVariantId,
  getVariantsByColor,
  getVariantBySingleOption,
  getAvailableProductColors,
};